import React, { useEffect } from "react";
import { X } from "lucide-react";

const SIZES = { md: "max-w-xl", lg: "max-w-3xl", xl: "max-w-5xl" };

// Compact modal with sticky header/footer; wide sizes let forms use several columns to stay short.
export default function Modal({ open, onClose, title, subtitle, size = "lg", children, footer, testId }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-[1px] flex items-center justify-center p-4" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div role="dialog" aria-modal="true" aria-label={title} data-testid={testId}
        className={`bg-white rounded-xl shadow-2xl w-full ${SIZES[size] || SIZES.lg} max-h-[92vh] flex flex-col`}>
        <div className="px-5 py-3.5 border-b border-slate-200 flex items-start justify-between gap-4">
          <div>
            <h2 className="font-display text-[15px] font-bold text-neutral-900">{title}</h2>
            {subtitle && <p className="text-[12px] text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          <button onClick={onClose} aria-label="Close" className="w-8 h-8 -mr-1.5 rounded-lg text-slate-500 hover:bg-slate-100 hover:text-neutral-900 flex items-center justify-center"><X size={17} /></button>
        </div>
        <div className="px-5 py-4 overflow-y-auto flex-1">{children}</div>
        {footer && <div className="px-5 py-3 border-t border-slate-200 bg-slate-50/70 rounded-b-xl flex items-center justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}
